import { LocalizedEnum, lt } from '@mews/framework';
import { SelectField, SelectFieldProps } from '@mews-commander/form';
import { createOption } from '@mews-commander/ui';
import { PortfolioAmountPart } from '@mews-commander/data-access';

export const PercentageAdjustmentSelect = ({
    ...props
}: Pick<SelectFieldProps, 'name' | 'inline' | 'disabled' | 'onChange'>) => {
    const amountPartOptions = Object.values(PortfolioAmountPart).map((k) =>
        createOption({
            value: k,
            label: <LocalizedEnum prefix="AmountPart" value={k} />,
        })
    );

    return (
        <SelectField
            required
            label={lt('ConfigureProductServicesFieldApplyTo')}
            options={amountPartOptions}
            {...props}
        />
    );
};
